import { checkIsLoggedIn } from "@services/client/user-service";
import { trackEvent } from "@acko-tech/building-blocks.ui.acko-analytics";
import { getDeviceModel, getDevicePlatform } from "./device-utils";

export const TRACK_TIMEOUT_MS = 3000;

export const getSegmentEventCommonProps = async () => {
  const { user: userData } = await checkIsLoggedIn()
  const deviceType = getDeviceModel();
  let url = "";
  let source = "";

  if (typeof window !== "undefined") {
    url = window.location.href || "";
    source = document.referrer || "";
  }

  const queryParams =
    typeof window !== "undefined"
      ? new URLSearchParams(window.location.search)
      : null;
  return {
    device_model: deviceType,
    phone: userData?.phone || "",
    email: userData?.email || "",
    dob: userData?.date_of_birth || "",
    address: userData?.addresses?.[0] || {},
    from_page: source,
    platform: getDevicePlatform(),
    utm_source: queryParams ? queryParams.get("utm_source") || "" : "",
    utm_campaign: queryParams ? queryParams.get("utm_campaign") || "" : "",
    utm_content: queryParams ? queryParams.get("utm_content") || "" : "",
    utm_medium: queryParams ? queryParams.get("utm_medium") || "" : "",
    url,
  };
};

export const trackWithCommonProps = async (
  eventName?: string,
  eventProperties: Record<string, unknown> = {},
): Promise<void> => {
  if (!eventName) return;
  const trackPromise = (async () => {
    const common = await getSegmentEventCommonProps();
    return trackEvent(eventName, { ...eventProperties, ...common });
  })();
  trackPromise.catch(() => undefined);

  try {
    await Promise.race([
      trackPromise,
      new Promise<void>((resolve) => setTimeout(resolve, TRACK_TIMEOUT_MS)),
    ]);
  } catch {
    // Analytics failure must never block the user journey.
  }
};
